import {
  BlackSpiderWeb,
  Eagle,
  SmallGhost,
  SmallSpiderWeb,
} from "../../../../assets/holidays/icons";

/**
 * Theme-specific decorations (canopy, mascots, banners).
 * Particles stay in SeasonalOverlay.
 */
function SeasonalThemeDecor({ themeId, witchFly, onAmbientClick, reducedMotion, lit, onBulbClick, ChristmasLights }) {
  if (themeId === "winter") {
    return (
      <ChristmasLights
        interactive={!reducedMotion}
        onBulbClick={onBulbClick}
        lit={lit}
      />
    );
  }

  if (themeId === "halloween") {
    return (
      <div className="seasonal-corners" aria-hidden="true">
        <BlackSpiderWeb className="seasonal-web seasonal-web--tl" />
        <SmallSpiderWeb className="seasonal-web seasonal-web--tr" />
        <SmallSpiderWeb className="seasonal-web seasonal-web--bl" />
        <BlackSpiderWeb className="seasonal-web seasonal-web--br" />
        <button
          type="button"
          className="seasonal-haunt"
          aria-label="Boo — spooky ghost"
          onClick={onAmbientClick}
        >
          <SmallGhost />
        </button>
        {witchFly ? <div className="seasonal-witch" aria-hidden="true" /> : null}
      </div>
    );
  }

  if (themeId === "thanksgiving") {
    return (
      <div className="seasonal-thanks">
        <div className="seasonal-harvest-canopy" aria-hidden="true">
          <div className="seasonal-harvest-lights">
            {Array.from({ length: 28 }, (_, i) => (
              <span
                key={i}
                className="seasonal-harvest-lights__bulb"
                style={{ animationDelay: `${(i % 7) * 0.22}s` }}
              />
            ))}
          </div>
          <div className="seasonal-harvest-maple">
            {Array.from({ length: 16 }, (_, i) => (
              <span
                key={i}
                className={`seasonal-harvest-maple__leaf seasonal-harvest-maple__leaf--${i % 5}`}
                style={{
                  left: `${3 + i * 6}%`,
                  animationDelay: `${i * 0.12}s`,
                }}
              />
            ))}
          </div>
        </div>
        <button
          type="button"
          className="seasonal-turkey"
          aria-label="Thanksgiving turkey — click for sparks"
          title="Happy Thanksgiving"
          onClick={onAmbientClick}
        >
          <span className="seasonal-turkey__tail" aria-hidden="true" />
          <span className="seasonal-turkey__body" aria-hidden="true" />
          <span className="seasonal-turkey__head" aria-hidden="true" />
        </button>
        <button
          type="button"
          className="seasonal-ambient-burst seasonal-ambient-burst--thanks"
          aria-label="Scatter Thanksgiving feast"
          title="Kliko për festë"
          onClick={onAmbientClick}
        />
      </div>
    );
  }

  if (themeId === "autumn") {
    return (
      <button
        type="button"
        className="seasonal-ambient-burst"
        aria-label="Scatter leaves"
        title="Kliko për gjethe"
        onClick={onAmbientClick}
      />
    );
  }

  if (themeId === "summer") {
    return (
      <div className="seasonal-summer">
        <div className="seasonal-summer__sun" aria-hidden="true" />
        <div
          className="seasonal-summer__wave seasonal-summer__wave--1"
          aria-hidden="true"
        />
        <div
          className="seasonal-summer__wave seasonal-summer__wave--2"
          aria-hidden="true"
        />
        <button
          type="button"
          className="seasonal-summer__umbrella"
          aria-label="Summer vacation — click for sparks"
          title="Verë / Vacation"
          onClick={onAmbientClick}
        />
      </div>
    );
  }

  if (themeId === "albaniaFlag") {
    return (
      <div className="seasonal-albania">
        <div className="seasonal-albania__banner" aria-hidden="true">
          <span className="seasonal-albania__stripe" />
          <Eagle className="seasonal-albania__eagle" />
          <span className="seasonal-albania__stripe" />
        </div>
        <button
          type="button"
          className="seasonal-albania__badge"
          aria-label="Dita e Flamurit — kliko"
          title="28 Nëntor — Dita e Flamurit"
          onClick={onAmbientClick}
        >
          <Eagle />
          <span>28 Nëntor</span>
        </button>
      </div>
    );
  }

  return null;
}

export default SeasonalThemeDecor;
